import styled from "styled-components";

export const TrialTextStyled = styled.div<{ isUserWithoutTrial: boolean; isBoldText: boolean }>`
    margin-right: 16px;
    margin-left: ${({ isUserWithoutTrial }) => (isUserWithoutTrial ? "7px" : "12px")};
    font-weight: ${({ isBoldText }) => (isBoldText ? "bold" : "normal")};
`;
